import { render } from "./FmuButton.vue?vue&type=template&id=fa1390aa&scoped=true"
import script from "./FmuButton.vue?vue&type=script&lang=js"
export * from "./FmuButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1390aa"]])

export default __exports__